import { Box, Typography } from "@mui/material";
import { useCustomThemeContext } from "../../lib/contexts/ThemeContext";

export default function Unauthorized() {
  const { custom } = useCustomThemeContext();

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        background: custom.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "20px",
        gap: "10px",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        You are not authorized to access this page.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Please contact edwin@gargantua.llc for access.
      </Typography>
    </Box>
  );
}
